export default __webpack_public_path__ + "static/media/190629_190332_IMG_4520.37f81e50.jpg";